export class RenditionTypeInfo {
    public __classname__: string = 'RenditionTypeInfo';

    public Rendition : string | null = null;
	public Type: string | null = null;

    constructor(
        Rendition : string | null = null, 
        Type: string | null = null
    ) {
        this.Rendition = Rendition;
        this.Type = Type;
    }
}